export default __webpack_public_path__ + "static/media/metamask.4a0bdb86.png";